export default function() {
  return data[process.env.VUE_APP_ANIMATION_DATA_SET];
}

let data = {
  vmware: {
    zoneOne: {
      intro: {
        text: "Reduce Operational Cost",
        title: "SMART ENERGY",
        arrowPosition: "right",
        position: { left: 10, bottom: 42 },
        ref: "buildingOneAnimation",
        goToPoint: "buildingOneAnimation"
      },
      painCard: {
        text:
          "Unplanned downtime affecting 82% of businesses (Vanson Bourne global study)",
        arrowPosition: "right",
        position: { left: 10, bottom: 45 },
        ref: "buildingOneAnimation",
        goToPoint: undefined,
        voiceOver: "smart-energy-vo-2.mp3"
      },
      technologyLandscape: {
        text:
          "Products used: Dell Edge Gateway, VMC on Dell EMC, VMware Pulse IoT Center, Dell Boomi, and VeloCloud SD-WAN",
        arrowPosition: "right",
        position: { left: 10, bottom: 45 },
        goToPoint: undefined,
        voiceOver: "smart-energy-vo-8.mp3"
      },
      benefitCard: {
        text: [
          "Automates management at scale",
          "Extends IT security standards to the Edge and IoT infrastructure",
          "Streamlines data collection and orchestration"
        ],
        arrowPosition: "right",
        position: { left: 10, bottom: 10 },
        goToPoint: undefined,
        voiceOver: "smart-energy-vo-9.mp3"
      },
      stopTimes: [
        {
          stopTime: 50,
          text: "smart meter monitoring detects the signs of a power outage",
          arrowPosition: "left",
          position: { left: 11.8, bottom: 49 },
          goToPoint: undefined,
          voiceOver: "smart-energy-vo-3.mp3"
        },
        {
          stopTime: 144,
          text: "Reserve supply automatically switches on to restore service",
          arrowPosition: "left",
          position: { left: 7.9, bottom: 53 },
          goToPoint: "buildingOneAnimationTwo",
          voiceOver: "smart-energy-vo-4.mp3"
        },
        {
          stopTime: 330,
          text:
            "The cause is determined and the issue is quickly resolved, restoring the original configuration",
          arrowPosition: "left",
          position: { left: 3.8, bottom: 45.4 },
          goToPoint: "buildingOneAnimation",
          voiceOver: "smart-energy-vo-5.mp3"
        },
        {
          stopTime: 500,
          text: [
            {
              text: "Faster problem recognition",
              icon: "faster-problem-resolution.svg"
            },
            {
              text: "Resolution and Reduced costs",
              icon: "reduced-cost.svg"
            }
          ],
          isIndBenefit: true,
          arrowPosition: "left",
          position: { left: 15.8, bottom: 46 },
          goToPoint: undefined,
          voiceOver: "smart-energy-vo-6.mp3"
        },
        {
          stopTime: 670,
          text:
            "IoT applications in cities have the potential to create between $0.9 trillion and $1.7 trillion in global value per year in 2025 (McKinsey Global Institute)",
          arrowPosition: "left",
          position: { left: 11.8, bottom: 49 },
          goToPoint: undefined,
          voiceOver: "smart-energy-vo-7.mp3"
        }
      ]
    },
    zoneTwo: {
      intro: {
        text: "Optimize energy distribution and consumption",
        title: "ENERGY EFFICIENCY",
        arrowPosition: "right",
        position: { left: 11, bottom: 50 },
        ref: "EnergyBuildingAnimation",
        goToPoint: "EnergyBuildingAnimation"
      },
      painCard: {
        text:
          "On average, 30% of the energy used in commercial buildings is wasted.",
        arrowPosition: "right",
        position: { left: 14, bottom: 55 },
        ref: "EnergyBuildingAnimation",
        goToPoint: "EnergyBuildingAnimation",
        voiceOver: "energy-efficiency-vo-2.mp3"
      },
      technologyLandscape: {
        text:
          "Products used: VMware Pulse IoT Center, Dell Edge Gateways, VMC on Dell EMC, and Dell Boomi",
        arrowPosition: "right",
        position: { left: 14, bottom: 55 },
        goToPoint: undefined,
        voiceOver: "energy-efficiency-vo-7.mp3"
      },
      benefitCard: {
        text: [
          "Automates management at scale",
          "Extends IT security standards to the Edge and IoT infrastructure"
        ],
        arrowPosition: "right",
        position: { left: 10, bottom: 10 },
        goToPoint: undefined,
        voiceOver: "energy-efficiency-vo-8.mp3"
      },
      stopTimes: [
        {
          stopTime: 24,
          text: "Energy demand is being monitored continuously",
          position: { left: 14.4, bottom: 62 },
          voiceOver: "energy-efficiency-vo-3.mp3"
        },
        {
          stopTime: 144,
          text:
            "As the demand increases, supply adjusts to provide optimal energy levels",
          position: { left: 18, bottom: 60 },
          voiceOver: "energy-efficiency-vo-4.mp3"
        },
        {
          stopTime: 360,
          text: [
            {
              text: "Reduced CO2 emissions",
              icon: "reduced-co2-emissions.svg"
            },
            { text: "Reduced cost", icon: "reduced-cost.svg" }
          ],
          isIndBenefit: true,
          position: { left: 19.4, bottom: 59 },
          voiceOver: "energy-efficiency-vo-5.mp3"
        },
        {
          stopTime: 560,
          text:
            "IoT enabled solutions can help save 9.1 gigatons in global greenhouse gas emissions (Carbon War Room)",
          arrowPosition: "center",
          position: { left: 16, bottom: 60 },
          voiceOver: "energy-efficiency-vo-6.mp3"
        }
      ]
    },
    zoneThree: {
      intro: {
        text: "Improve disaster management response times",
        title: "Emergency response",
        arrowPosition: "right",
        position: { left: 32, bottom: 48 },
        ref: "smartTransportationInfrastructure",
        goToPoint: "smartTransportationInfrastructure"
      },
      painCard: {
        text:
          "In 2016, 25 fires in the U.S. resulted in a total of $1.4 billion in direct property losses and 14 civilian deaths (NFPA)",
        arrowPosition: "right",
        position: { left: 35, bottom: 60 },
        ref: undefined,
        goToPoint: undefined,
        voiceOver: "emergency-response-vo-2.mp3"
      },
      technologyLandscape: {
        text:
          "Products used: VMware Pulse IoT Center, VMC on Dell EMC, VeloCloud SD-WAN, Dell Edge Gateway, and Dell Boomi",
        arrowPosition: "right",
        position: { left: 35, bottom: 60 },
        goToPoint: undefined,
        voiceOver: "emergency-response-vo-7.mp3"
      },
      benefitCard: {
        text: [
          "Automates management at scale",
          "Reduces time and technical skills required to onboard devices",
          "Streamlines data collection and orchestration",
          "Extends IT security standards to the Edge and IoT infrastructure"
        ],
        arrowPosition: "right",
        position: { left: 10, bottom: 10 },
        goToPoint: undefined,
        voiceOver: "emergency-response-vo-8.mp3"
      },
      stopTimes: [
        {
          stopTime: 50,
          text: "Alerts are triggered immediately for first responders",
          goToPoint: undefined,
          position: { left: 33.5, bottom: 63.5 },
          voiceOver: "emergency-response-vo-3.mp3"
        },
        {
          stopTime: 200,
          text: "Smart traffic management assists during emergencies",
          goToPoint: "smartTransportationInfrastructureTwo",
          position: { left: 36.9, bottom: 48 },
          voiceOver: "emergency-response-vo-4.mp3"
        },
        {
          stopTime: 420,
          text: [
            {
              text: "Faster incident response",
              icon: "faster-incident-response.svg"
            },
            {
              text: "Improved citizen safety",
              icon: "improved-citizen-safety.svg"
            }
          ],
          isIndBenefit: true,
          arrowPosition: "right",
          goToPoint: "smartTransportationInfrastructure",
          position: { left: 38, bottom: 59 },
          voiceOver: "emergency-response-vo-5.mp3"
        },
        {
          stopTime: 690,
          text:
            "IoT applications in cities have the potential to create between $0.9 trillion and $1.7 trillion in global value per year in 2025 (McKinsey Global Institute)",
          arrowPosition: "center",
          goToPoint: undefined,
          position: { left: 30, bottom: 60 },
          voiceOver: "emergency-response-vo-6.mp3"
        }
      ]
    },
    zoneFour: {
      intro: {
        text:
          "Transform vehicular and public transportation to help improve traffic flow and save citizen's time",
        title: "PROACTIVE TRANSPORT",
        arrowPosition: "right",
        position: { left: 40, bottom: 37 },
        ref: "proactivePublicTransportAnimation",
        goToPoint: "proactivePublicTransportAnimation"
      },
      painCard: {
        text:
          "The average American worker spends 20% more time commuting now than they did in the 1980's (US Census Data)",
        arrowPosition: "right",
        position: { left: 34.4, bottom: 40 },
        ref: "proactivePublicTransportAnimation",
        goToPoint: undefined,
        voiceOver: "proactive-transport-vo-2.mp3"
      },
      technologyLandscape: {
        text:
          "Products used: Dell Edge Gateway, VMC on Dell EMC, Pulse IoT Center, and Dell Boomi software",
        arrowPosition: "right",
        position: { left: 34.4, bottom: 37 },
        goToPoint: "proactivePublicTransportAnimation",
        voiceOver: "proactive-transport-vo-7.mp3"
      },
      benefitCard: {
        text: [
          "Automates management at scale",
          "Reduces time and technical skills required to onboard devices",
          "Extends IT security standards to the Edge and IoT infrastructure"
        ],
        delay: 7000,
        arrowPosition: "left",
        position: { left: 42.5, bottom: 46 },
        goToPoint: "proactivePublicTransportAnimationTwo",
        voiceOver: "proactive-transport-vo-8.mp3"
      },
      stopTimes: [
        {
          stopTime: 50,
          text: "Smart parking solutions help save time",
          arrowPosition: "left",
          position: { left: 40, bottom: 41 },
          goToPoint: undefined,
          voiceOver: "proactive-transport-vo-3.mp3"
        },
        {
          stopTime: 200,
          text:
            "Citizens can choose the best public transportation option available",
          arrowPosition: "left",
          position: { left: 43, bottom: 43 },
          goToPoint: undefined,
          voiceOver: "proactive-transport-vo-4.mp3"
        },
        {
          stopTime: 350,
          text: [
            {
              text: "Reduced carbon emissions",
              icon: "reduced-co2-emissions.svg"
            },
            { text: "Saved time", icon: "saved-time.svg" }
          ],
          isIndBenefit: true,
          arrowPosition: "left",
          position: { left: 51, bottom: 35 },
          goToPoint: "proactivePublicTransportAnimationTwo",
          voiceOver: "proactive-transport-vo-5.mp3"
        },
        {
          stopTime: 800,
          text:
            "IoT applications in transportation can free up at least 30% of urban congestion (Intelligent Transportation Society of America.)",
          arrowPosition: "center",
          position: { left: 40, bottom: 40 },
          goToPoint: "proactivePublicTransportAnimation",
          voiceOver: "proactive-transport-vo-6.mp3"
        }
      ]
    },
    zoneFive: {
      intro: {
        text: "Improve traffic control and flow",
        title: "REDUCE CONGESTION",
        arrowPosition: "right",
        position: { left: 63, bottom: 45 },
        ref: "trafficAnimation",
        goToPoint: "trafficAnimation"
      },
      painCard: {
        text:
          "Approximately $160 billion is wasted in the U.S. every year due to traffic congestion (Texas A&M University)",
        arrowPosition: "right",
        position: { left: 60, bottom: 50 },
        ref: "trafficAnimation",
        goToPoint: undefined,
        voiceOver: "reduce-congestion-vo-2.mp3"
      },
      technologyLandscape: {
        text:
          "Products used: Dell Edge Gateway, VMC on Dell EMC, and VMware Pulse IoT Center",
        arrowPosition: "right",
        position: { left: 60, bottom: 50 },
        goToPoint: undefined,
        voiceOver: "reduce-congestion-vo-7.mp3"
      },
      benefitCard: {
        text: [
          "Automates management at scale",
          "Reduces time and technical skill required to onboard devices",
          "Extends IT security standards to the Edge and IoT infrastructure"
        ],
        arrowPosition: "right",
        position: { left: 50, bottom: 50 },
        goToPoint: undefined,
        voiceOver: "reduce-congestion-vo-8.mp3"
      },
      stopTimes: [
        {
          stopTime: 24,
          text: "Traffic is being monitored continuously",
          position: { left: 60, bottom: 54 },
          voiceOver: "reduce-congestion-vo-3.mp3"
        },
        {
          stopTime: 216,
          text:
            "Smart traffic management helps provide better oversight for the flow and volume of heavy traffic",
          arrowPosition: "right",
          position: { left: 52, bottom: 54 },
          voiceOver: "reduce-congestion-vo-4.mp3"
        },
        {
          stopTime: 528,
          text: [
            {
              text: "Improved traffic flow",
              icon: "reduced-co2-emissions.svg"
            },
            { text: "Saves commuters time", icon: "saved-time.svg" }
          ],
          isIndBenefit: true,
          goToPoint: "trafficAnimationTwo",
          position: { left: 48, bottom: 52 },
          voiceOver: "reduce-congestion-vo-5.mp3"
        },
        {
          stopTime: 760,
          text:
            "IoT applications in transportation can free up at least 30% of urban congestion (Intelligent Transportation Society of America)",
          arrowPosition: "center",
          goToPoint: "trafficAnimation",
          position: { left: 64, bottom: 54 },
          voiceOver: "reduce-congestion-vo-6.mp3"
        }
      ]
    },
    zoneSix: {
      intro: {
        text: "Enable a smart connected supply chain",
        title: "IMPROVE SUPPLY CHAIN",
        arrowPosition: "right",
        position: { left: 84, bottom: 52 },
        ref: "manufacturingOneAnimation",
        goToPoint: "manufacturingOneAnimation"
      },
      painCard: {
        text:
          "According to IBM, 79% of supply chain officers report that lack of visibility has a significant impact on supply chains",
        arrowPosition: "right",
        position: { left: 85, bottom: 50 },
        ref: "manufacturingOneAnimation",
        goToPoint: undefined,
        voiceOver: "improved-supply-vo-2.mp3"
      },
      technologyLandscape: {
        text:
          "Products used: Dell Edge Gateway, Pulse IoT Center, Pivotal data science solution, and Dell Boomi",
        arrowPosition: "right",
        position: { left: 85, bottom: 55 },
        goToPoint: undefined,
        voiceOver: "improved-supply-vo-8.mp3"
      },
      benefitCard: {
        text: [
          "Automates management at scale",
          "Reduces time and technical skills required to onboard devices",
          "Streamlines data collection and orchestration "
        ],
        arrowPosition: "right",
        position: { left: 10, bottom: 10 },
        goToPoint: undefined,
        voiceOver: "improved-supply-vo-9.mp3"
      },
      stopTimes: [
        {
          stopTime: 24,
          text: "The raw material inventory is being monitored continuously",
          arrowPosition: "right",
          position: { left: 79, bottom: 61 },
          goToPoint: "bakery",
          voiceOver: "improved-supply-vo-3.mp3"
        },
        {
          stopTime: 48,
          text: "Raw materials are ordered when the inventory is used",
          arrowPosition: "right",
          position: { left: 79, bottom: 61 },
          voiceOver: "improved-supply-vo-4.mp3"
        },
        {
          stopTime: 264,
          text: "The shipment's condition is being monitored continuously",
          arrowPosition: "right",
          position: { left: 62.5, bottom: 48 },
          goToPoint: "manufacturingOneAnimationTwo",
          voiceOver: "improved-supply-vo-5.mp3"
        },
        {
          stopTime: 432,
          text: [
            {
              text: "No inventory outage",
              icon: "no-inventory-outage.svg"
            },
            { text: "No asset build-up", icon: "no-asset-build-up.svg" }
          ],
          delay: 9000,
          arrowPosition: "right",
          isIndBenefit: true,
          goToPoint: "bakery",
          position: { left: 73, bottom: 58 },
          voiceOver: "improved-supply-vo-6.mp3"
        },
        {
          stopTime: 600,
          text:
            "IoT applications applied in manufacturing facilities have the potential to create an additional $1.2 to $3.7 trillion in value per year in 2025 (McKinsey Global Institute)",
          arrowPosition: "center",
          goToPoint: "bakery",
          position: { left: 81, bottom: 55 },
          voiceOver: "improved-supply-vo-7.mp3"
        }
      ]
    },
    zoneSeven: {
      intro: {
        text: "Modernize machine maintenance",
        title: "PROACTIVE MAINTENANCE",
        arrowPosition: "right",
        position: { left: 84, bottom: 47 },
        ref: "manufacturingTwoAnimation",
        goToPoint: undefined
      },
      painCard: {
        text:
          "Unplanned downtime costs industrial manufacturers an estimated $50 billion annually (WSJ)",
        arrowPosition: "right",
        position: { left: 88, bottom: 50 },
        ref: "manufacturingTwoAnimation",
        goToPoint: undefined,
        voiceOver: "proactive-maintenance-vo-2.mp3"
      },
      technologyLandscape: {
        text:
          "Products: VMware Pulse IoT Center, Dell Boomi, VMC on Dell EMC, and Dell Edge Gateway",
        arrowPosition: "right",
        position: { left: 77, bottom: 48 },
        goToPoint: undefined,
        voiceOver: "proactive-maintenance-vo-7.mp3"
      },
      benefitCard: {
        text: [
          "Reduces time and technical skills required to onboard devices",
          "Streamlines data collection and orchestration across any device, any application and on any cloud"
        ],
        arrowPosition: "right",
        position: { left: 10, bottom: 10 },
        goToPoint: undefined,
        voiceOver: "proactive-maintenance-vo-8.mp3"
      },
      stopTimes: [
        {
          stopTime: 24,
          text: "Condition of machines are being monitored continuously",
          arrowPosition: "right",
          position: { left: 82, bottom: 54 },
          voiceOver: "proactive-maintenance-vo-3.mp3"
        },
        {
          stopTime: 60,
          text:
            "Alerts are triggered, scheduling maintenance before the equipment malfunctions",
          arrowPosition: "right",
          position: { left: 87, bottom: 54 },
          voiceOver: "proactive-maintenance-vo-4.mp3"
        },
        {
          stopTime: 336,
          text: [
            {
              text: "No unscheduled downtime",
              icon: "no-unscheduled-downtime.svg"
            }
          ],
          isIndBenefit: true,
          arrowPosition: "right",
          position: { left: 77, bottom: 48 },
          voiceOver: "proactive-maintenance-vo-5.mp3"
        },
        {
          stopTime: 700,
          text:
            "IoT applications applied in manufacturing facilities have the potential to create an additional $1.2 to $3.7 trillion in value per year in 2025 (McKinsey Global Institute)",
          arrowPosition: "center",
          position: { left: 87, bottom: 54 },
          voiceOver: "proactive-maintenance-vo-6.mp3"
        }
      ]
    },
    zoneEight: {
      intro: {
        text: "Improve quality of care, patient outcomes and reduce costs",
        title: "PROACTIVE HEALTHCARE",
        arrowPosition: "right",
        position: { left: 40, bottom: 51 },
        ref: "healthCareOneAnimation",
        goToPoint: undefined
      },
      painCard: {
        text:
          "In the U.S., for every 100,000 rural patients, there are only 43 specialists available.",
        arrowPosition: "right",
        position: { left: 38, bottom: 55 },
        ref: "healthCareOneAnimation",
        goToPoint: undefined,
        voiceOver: "proactive-healthcare-vo-2.mp3"
      },
      technologyLandscape: {
        text:
          "Products used: Pulse IoT Center, VMC on Dell EMC, Dell Edge Gateway, vCloud NFV, and Dell Boomi",
        arrowPosition: "right",
        position: { left: 38, bottom: 55 },
        goToPoint: undefined,
        voiceOver: "proactive-healthcare-vo-7.mp3"
      },
      benefitCard: {
        text: [
          "Reduces time and technical skills required to onboard devices",
          "Extends IT security standards to the Edge and IoT infrastructure"
        ],
        arrowPosition: "right",
        position: { left: 10, bottom: 10 },
        goToPoint: undefined,
        voiceOver: "proactive-healthcare-vo-8.mp3"
      },
      stopTimes: [
        {
          stopTime: 72,
          text: "Patient's health and location is monitored in real-time",
          position: { left: 32.5, bottom: 54 },
          voiceOver: "proactive-healthcare-vo-3.mp3"
        },
        {
          stopTime: 216,
          text:
            "Prescriptions are ordered remotely and drones deliver medicines on time",
          position: { left: 44, bottom: 69 },
          goToPoint: "healthCareOneAnimationTwo",
          voiceOver: "proactive-healthcare-vo-4.mp3"
        },
        {
          stopTime: 336,
          text: [
            { text: "Dollars saved", icon: "dollars-saved.svg" },
            { text: "Healthy population", icon: "healthy-population.svg" }
          ],
          isIndBenefit: true,
          position: { left: 40.5, bottom: 55 },
          goToPoint: "healthCareOneAnimation",
          voiceOver: "proactive-healthcare-vo-5.mp3"
        },
        {
          stopTime: 720,
          text:
            "IoT applications in healthcare have the potential to create between $170 billion and $1.6 trillion in global value per year in 2025 (McKinsey Global Institute)",
          position: { left: 33, bottom: 55 },
          arrowPosition: "center",
          voiceOver: "proactive-healthcare-vo-6.mp3"
        }
      ]
    },
    zoneNine: {
      intro: {
        text: "Reduce patient wait times",
        title: "EQUIPMENT TRACKING",
        arrowPosition: "right",
        position: { left: 47, bottom: 56 },
        ref: "healthCareTwoAnimation",
        goToPoint: undefined
      },
      painCard: {
        text:
          "A NursingTimes.net survey polled 1000 nurses and found that at least one in three spent an hour or more per shift searching for medical equipment to use with their patients.",
        arrowPosition: "right",
        position: { left: 48, bottom: 65 },
        ref: "healthCareTwoAnimation",
        goToPoint: undefined,
        voiceOver: "equipment-tracking-vo-2.mp3"
      },
      technologyLandscape: {
        text:
          "Products used: VMware Pulse IoT Center, Dell Edge Gateway, VMCloud on Dell EMC, and Dell Boomi",
        arrowPosition: "right",
        position: { left: 48, bottom: 65 },
        goToPoint: undefined,
        voiceOver: "equipment-tracking-vo-6.mp3"
      },
      benefitCard: {
        text: [
          "Reduces time and technical skills required to onboard devices",
          "Streamlines data collection and orchestration",
          "Extends IT security standards to the Edge and IoT infrastructure"
        ],
        arrowPosition: "right",
        position: { left: 10, bottom: 10 },
        goToPoint: undefined,
        voiceOver: "equipment-tracking-vo-7.mp3"
      },
      stopTimes: [
        {
          stopTime: 24,
          text: "Medical equipment is being tracked in real-time",
          position: { left: 50, bottom: 69 },
          voiceOver: "equipment-tracking-vo-3.mp3"
        },
        {
          stopTime: 96,
          text: "Data from sensors are routed through gateways to doctors",
          position: { left: 51, bottom: 69 },
          voiceOver: "equipment-tracking-vo-3-2.mp3"
        },
        {
          stopTime: 168,
          text: [
            {
              text: "Optimized physical asset utilization",
              icon: "optimized-physical-asset-utilization.svg"
            },
            { text: "Reduced costs", icon: "reduced-cost.svg" }
          ],
          isIndBenefit: true,
          position: { left: 56.5, bottom: 65 },
          voiceOver: "equipment-tracking-vo-4.mp3"
        },
        {
          stopTime: 500,
          text:
            "IoT is said to provide at least a 25% reduction in costs by effective asset management and tracking in healthcare.",
          position: { left: 50, bottom: 69 },
          arrowPosition: "center",
          voiceOver: "equipment-tracking-vo-5.mp3"
        }
      ]
    },
    zoneTen: {
      intro: {
        text: "Create immersive shopping experience",
        title: "CUSTOMER LOYALTY",
        arrowPosition: "right",
        position: { left: 60, bottom: 58 },
        ref: "retailAnimation",
        goToPoint: undefined
      },
      painCard: {
        text:
          "According to Accenture, 81% of customers want companies to understand them better",
        arrowPosition: "right",
        position: { left: 60, bottom: 66 },
        ref: "retailAnimation",
        goToPoint: undefined,
        voiceOver: "customer-loyalty-vo-2.mp3"
      },
      technologyLandscape: {
        text:
          "Products used: VMware Pulse IoT Center, Dell Edge Gateway, and VMC on Dell EMC",
        arrowPosition: "right",
        position: { left: 60, bottom: 66 },
        goToPoint: undefined,
        voiceOver: "customer-loyalty-vo-7.mp3"
      },
      benefitCard: {
        text: [
          "Streamlines data collection and orchestration",
          "Reduces Edge and IoT complexity",
          "Facilitates data movement and integration"
        ],
        arrowPosition: "right",
        position: { left: 10, bottom: 10 },
        goToPoint: undefined,
        voiceOver: "customer-loyalty-vo-8.mp3"
      },
      stopTimes: [
        {
          stopTime: 40,
          text: "Store footfalls are monitored continuously",
          position: { left: 64.2, bottom: 67 },
          voiceOver: "customer-loyalty-vo-3.mp3"
        },
        {
          stopTime: 130,
          text: "Knowledgeable staff assists shoppers",
          position: { left: 64.2, bottom: 67 },
          voiceOver: "customer-loyalty-vo-4.mp3"
        },
        {
          stopTime: 288,
          text: [
            { text: "Reduced wait time", icon: "reduced-wait-time.svg" },
            {
              text: "Increased revenue",
              icon: "increased-revenue.svg"
            }
          ],
          isIndBenefit: true,
          position: { left: 71, bottom: 65 },
          voiceOver: "customer-loyalty-vo-5.mp3"
        },
        {
          stopTime: 650,
          text:
            "By 2023 retail IoT platforms are expected to generate more than four billion dollars in revenue through industry-wide efficiency gains.",
          position: { left: 64.2, bottom: 67 },
          voiceOver: "customer-loyalty-vo-6.mp3"
        }
      ]
    },
    zoneEleven: {
      intro: {
        text:
          "Improve efficiencies, safety, and cost controls for maritime transportation.",
        title: "Smart Ships",
        arrowPosition: "right",
        position: { left: 20, bottom: 32 },
        ref: "maritimeAnimation",
        goToPoint: "maritimeAnimation"
      },
      painCard: {
        text:
          "According to the European Maritime Safety Agency, of the 3,145 maritime safety incidents in 2016, half were caused by infrastructure issues with how ships navigate marine traffic and adverse weather.",
        arrowPosition: "right",
        position: { left: 20, bottom: 30 },
        ref: "maritimeAnimation",
        goToPoint: undefined,
        voiceOver: "smart-shipping-vo-2.mp3"
      },
      technologyLandscape: {
        text:
          "Dell solutions: Latitude Rugged laptops, Dell PowerEdge XR2 rugged servers, EMC VxRail, EMC Isilon, Dell N-Series point-of-entry switches, Dell 3002 IoT Edge gateways",
        arrowPosition: "right",
        position: { left: 20, bottom: 30 },
        goToPoint: undefined,
        voiceOver: "smart-shipping-vo-9.mp3"
      },
      benefitCard: {
        text: [
          "Intelligent Ship Compute Infrastructure provides vessel maintenance, safety, and performance information to the crew",
          "It also displays real-time alerts based on sensor parameters"
        ],
        arrowPosition: "right",
        position: { left: 20, bottom: 10 },
        goToPoint: undefined,
        voiceOver: "smart-shipping-vo-10.mp3"
      },
      stopTimes: [
        {
          stopTime: 24,
          text:
            "Citizens and goods board electric ferries operating on commands and feeds from remote control stations.",
          arrowPosition: "left",
          position: { left: 24.8, bottom: 35 },
          goToPoint: undefined,
          voiceOver: "smart-shipping-vo-3.mp3"
        },
        {
          stopTime: 324,
          text:
            "Sensor data from all ferry traffic streams live information to the control center to avert safety incidents.",
          arrowPosition: "left",
          position: { left: 16.8, bottom: 40 },
          goToPoint: "maritimeAnimationTwo",
          voiceOver: "smart-shipping-vo-4.mp3"
        },
        {
          stopTime: 452,
          text:
            "Data from the remote operations center reroutes the ship to avoid collisions.",
          arrowPosition: "left",
          position: { left: 41.8, bottom: 35 },
          goToPoint: "maritimeAnimationThree",
          voiceOver: "smart-shipping-vo-5.mp3"
        },
        {
          stopTime: 572,
          text: "The ferry feeds live arrival data to the destination port.",
          arrowPosition: "left",
          position: { left: 41.8, bottom: 35 },
          goToPoint: undefined,
          voiceOver: "smart-shipping-vo-6.mp3"
        },
        {
          stopTime: 779,
          text: [
            {
              text: "Improved efficiencies",
              icon: "improved-efficiencies.svg"
            },
            {
              text: "Improved safety standards",
              icon: "improved-safety-standards.svg"
            }
          ],
          isIndBenefit: true,
          position: { left: 30, bottom: 38 },
          goToPoint: "maritimeAnimation",
          voiceOver: "smart-shipping-vo-7.mp3"
        },
        {
          stopTime: 1332,
          text:
            "The autonomous shipping industry is due to reach $13.8 billion by 2030 (MarketsandMarkets Research Private Ltd.).",
          position: { left: 30, bottom: 35 },
          goToPoint: undefined,
          voiceOver: "smart-shipping-vo-8.mp3"
        }
      ]
    },
    zoneTwelve: {
      intro: {
        text: "Transform safety and security within a city.",
        title: "Smart Surveillance",
        arrowPosition: "right",
        position: { left: 78, bottom: 55 },
        ref: "surveillanceAnimation",
        goToPoint: "surveillanceAnimation"
      },
      painCard: {
        text:
          "A study published by Security Oz states that humans can effectively monitor continuous video for 22 minutes. After that, they miss 95 percent of screen activity.",
        arrowPosition: "right",
        position: { left: 75, bottom: 60 },
        ref: "surveillanceAnimation",
        goToPoint: undefined,
        voiceOver: "smart-surveillance-vo-2.mp3"
      },
      technologyLandscape: {
        text:
          "Dell solutions: Dell IoT for surveillance foundational architecture, hyper-converged infrastructure (powered by VMware vSAN, vSphere, vCenter), management through Pulse IoT Center; storage by ISILON or elastic cloud storage",
        arrowPosition: "right",
        position: { left: 75, bottom: 60 },
        goToPoint: undefined,
        voiceOver: "smart-surveillance-vo-9.mp3"
      },
      benefitCard: {
        text: [
          "Dell Technologies' IoT Surveillance is a software-defined infrastructure system with tightly integrated compute, storage, networking, and virtualization resources that improve system performance.",
          "The system also lowers the total cost of ownership, allowing you to reach time to value faster."
        ],
        arrowPosition: "right",
        position: { left: 60, bottom: 60 },
        goToPoint: undefined,
        voiceOver: "smart-surveillance-vo-10.mp3"
      },
      stopTimes: [
        {
          stopTime: 24,
          text:
            "Security cameras across the city monitor theft, disturbances, and unauthorized entry.",
          arrowPosition: "left",
          position: { left: 73.8, bottom: 60 },
          goToPoint: undefined,
          voiceOver: "smart-surveillance-vo-3.mp3"
        },
        {
          stopTime: 100,
          text: "A disturbance within the city is captured in real time.",
          arrowPosition: "left",
          position: { left: 79, bottom: 56 },
          goToPoint: "surveillanceAnimationTwo",
          voiceOver: "smart-surveillance-vo-4.mp3"
        },
        {
          stopTime: 200,
          text:
            "Real-time theft footage triggers analysis and reporting of the instance.",
          arrowPosition: "left",
          position: { left: 75, bottom: 62 },
          goToPoint: "surveillanceAnimation",
          voiceOver: "smart-surveillance-vo-5.mp3"
        },
        {
          stopTime: 275,
          text: "Alerts are immediately sent to first responders.",
          arrowPosition: "left",
          position: { left: 71.4, bottom: 63 },
          goToPoint: undefined,
          voiceOver: "smart-surveillance-vo-6.mp3"
        },
        {
          stopTime: 400,
          text: [
            { text: "Reduced crime", icon: "reduced-crime.svg" },
            {
              text: "Alerts are immediately sent to first responders.",
              icon: "first-responders.svg"
            }
          ],
          isIndBenefit: true,
          position: { left: 60, bottom: 55 },
          goToPoint: "surveillanceAnimationTwo",
          voiceOver: "smart-surveillance-vo-7.mp3"
        },
        {
          stopTime: 562,
          text:
            "By 2025, monitoring/surveillance and crime detection efforts are expected to save $14 to $31 billion for cities (McKinsey & Company).",
          position: { left: 68, bottom: 55 },
          goToPoint: "surveillanceAnimation",
          voiceOver: "smart-surveillance-vo-8.mp3"
        }
      ]
    }
  }
};
